import React, { useState, useEffect,useContext } from 'react';
import axios from "axios"
import ShopItem from './Item'
import Filters from './Filter';
import LoadingContext from './Contexts/LoadingContext';
import ListOfItemsPs from './placeholders/listOfItemsPs';
import settings from '../../settings.json'
import CollectionPs from './placeholders/CollectionPs';
import CollectionHomeDetail from './details/CollectionHomeDetail';
import {GenericSlider} from '../MySlider'

function HomeShop() {
    const [next, setNext] = useState(undefined)
    const [results, setResults] = useState([])
    const [loading, setLoading] = useState(true)
    const contextLoading = useContext(LoadingContext)
    const [collections, setCollections] = useState(null)

    function filter(categoryId,collectionId){
        contextLoading.LoadingDispatch({type:"ADD_TO_LOADING",payload:70})
        let addIdCategory=""
        if(categoryId !== null){
            addIdCategory="&cat="+categoryId        
        }
        let addIdCollection=""
        if(collectionId !== null){
            addIdCollection="&col="+collectionId        
        }
        contextLoading.LoadingDispatch({type:"ADD_TO_LOADING",payload:90})
        axios.get(settings.url_api+"/api/products/?"+addIdCategory+""+addIdCollection).then((res)=>{
            setNext(res.data.next)
            setResults(res.data.results)
            contextLoading.LoadingDispatch({type:"ADD_TO_LOADING",payload:100})
            contextLoading.LoadingDispatch({type:"COMPLETE"})
            setLoading(false)
        })
    }
    useEffect(() => {
        contextLoading.LoadingDispatch({type:"ADD_TO_LOADING",payload:50})
        filter(null,null)
    }, [])
    return (
        <div>
            <div className="row">
                    <div className="col-12 d-none d-md-block" >
                    {collections && collections.length > 0 ?
                        <div className="col-12 home-collections-block">
                            <GenericSlider arrows={false} dots={false}>
                                {collections.map((collection,i)=>{
                                    return(
                                        <CollectionHomeDetail key={i} collection={collection} filter={filter}></CollectionHomeDetail>
                                    )
                                })}
                            </GenericSlider>
                        </div>
                    : null}
                    </div>
                <div className="col-lg-3 col-md-3 col-sm-3 d-block">
                    <Filters setCollections={setCollections} filter={filter}></Filters>
                </div>
                <div className="col-lg-9 col-md-9 col-sm-9 col-xs-12">
                    {loading ?  
                    <ListOfItemsPs/> :
                    <>
                    <div className="row">
                        {results.map((prodotto,i)=>{
                            return(
                                <ShopItem key={i} item={prodotto}></ShopItem>
                            )
                        })}
                    </div>
                    </>
                    }
                </div>
            </div>
        </div>
    );
}

export default HomeShop;